import $ from 'jquery';
import { anyChecked } from './utilities';
import timePicker from "../../components/timePicker/timePicker";
import { isPresent } from '../../utilities/general';
import { setElementsFromScope, setRequired, removeRequired} from "../../utilities/selectorHelpers";
import { setSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
import render from "../../utilities/render";

export default function walmartConfigurationTab(wizard) {
  const self = this;
  const el = wizard.getWizardElement();

  self.didNavigateToForm = function () {
    return validateConfigTab();
  };
      
  const retpartner = el.data("retailer-partners-info");
  let startDateValue = el.data("start-date-value");
  let timePickerHoursSelectValue = el.data("time-picker-hours-select-value");
  let timePickerMinSelectValue = el.data("time-picker-minutes-select-value");
  let timePickerPeriodSelectValue = el.data("time-picker-period-select-value");
  let orderProcessingDateTimeSelectList;
  let elsPage = {};
  const elsMap = {
    orderProcessingTogglers: "#walmartOrderProcessingCheck",
    orderProcessingDateTimeSelect: "#orderProcessingDateTimeOptions",
    dateTimePickerSection: "#order-processing-date-time-picker",
    startDate: ".start-date",
    timePickerHoursSelect: ".time-picker-hours-select",
    timePickerMinSelect: ".time-picker-minutes-select",
    timePickerPeriodSelect: ".time-picker-period-select",
    timePickerTarget: '.time-picker',
    inventorySyncingTogglers: "#walmartInventorySyncingCheck"
  };

  self.init = function() {
    setElements();
    bindElements();
    orderProcessingDateTimeDropdown();
    if(!isPresent(retpartner)) {
      setRequired([elsPage.orderProcessingDateTimeSelect]);
    }
    loadConfiguration(retpartner);
  };

  function setElements() {
    setElementsFromScope(elsPage, elsMap, el);
  }

  function validateConfigTab() {
    let isValid = false;
    if (el.valid()) {
      isValid = true;
    }
    return isValid;
  }

  function bindElements() {
    elsPage.orderProcessingTogglers.on("change", function () {
        toggleOrderProcessingDateTime(this.value, this.text);
    });
    elsPage.orderProcessingDateTimeSelect.on('change', function () {
        orderProcessingSelectChanged(this.value, this.text);
    });
    timePicker(elsPage.timePickerTarget);
    orderProcessingDateTimeSelectList = elsPage.orderProcessingDateTimeSelect.data('options');
    elsPage.inventorySyncingTogglers.on("change", function () {
        toggleInventorySyncSwitch(this.id, this.value);
    });
  }

  function toggleInventorySyncSwitch(toggleSwitchId, toggleSwitchValue) {
    let isOn = anyChecked(elsPage.inventorySyncingTogglers);
    if (toggleSwitchId == elsPage.inventorySyncingTogglers) {
        if (isOn) {
            elsPage.inventorySyncingTogglers.val(true);
            elsPage.inventorySyncingTogglers.prop('checked', true);
        } else {
            elsPage.inventorySyncingTogglers.val(false);
            elsPage.inventorySyncingTogglers.prop('checked', false);
        }
    }
  }

  function orderProcessingDateTimeDropdown() {
    let returnTypeList = "";
    returnTypeList = orderProcessingDateTimeSelectList.map((el) => {
        return render("<option value = '{%-key %}'>{%-value %}</option>", {
            key: el.cdmValue,
            value: el.cdmDescription

        });
    });
    elsPage.orderProcessingDateTimeSelect.html(returnTypeList);
    elsPage.orderProcessingDateTimeSelect.val("");
    elsPage.orderProcessingDateTimeSelect.trigger('change');
  }

  function loadConfiguration(data) {
    loadOrderProcessingConfiguration(data);
    toggleOrderProcessingDateTime(elsPage.orderProcessingTogglers, data.repOrdersProcessingFlag);
    let isOn = anyChecked(elsPage.orderProcessingTogglers);
    if(isPresent(data) && isOn) {
      elsPage.dateTimePickerSection.show();
      elsPage.startDate.val(startDateValue);
      elsPage.startDate.change();
      elsPage.timePickerHoursSelect.val(timePickerHoursSelectValue);
      elsPage.timePickerHoursSelect.change();
      elsPage.timePickerMinSelect.val(timePickerMinSelectValue);
      elsPage.timePickerMinSelect.change();
      elsPage.timePickerPeriodSelect.val(timePickerPeriodSelectValue);
      elsPage.timePickerPeriodSelect.change();
    }

    loadInventorySyncConfiguration(data);
    toggleInventorySyncSwitch(elsPage.inventorySyncingTogglers, data.repInventorySyncFlag);
  }

  function loadInventorySyncConfiguration(data) {
    if (data.repInventorySyncFlag) {
        instantiateSwitchery(elsPage.inventorySyncingTogglers, {});
        setSwitchery(elsPage.inventorySyncingTogglers, data.repInventorySyncFlag);
    }
  }

  function loadOrderProcessingConfiguration(data) {
    if (data.repOrdersProcessingFlag) {
        instantiateSwitchery(elsPage.orderProcessingTogglers, {});
        setSwitchery(elsPage.orderProcessingTogglers, data.repOrdersProcessingFlag);
    }
  }

  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
    let isOn = anyChecked(elsPage.orderProcessingTogglers);
    elsPage.dateTimePickerSection.hide();
    if (isOn) {
      elsPage.dateTimePickerSection.show();
      elsPage.orderProcessingDateTimeSelect.change();
      elsPage.orderProcessingTogglers.val(true);
      elsPage.orderProcessingTogglers.prop('checked', true);
    } else {
      elsPage.dateTimePickerSection.hide();
      orderProcessingSelectChanged(null, null);
      elsPage.orderProcessingDateTimeSelect.val("");
      elsPage.orderProcessingTogglers.val(false);
      elsPage.orderProcessingTogglers.prop('checked', false);
    }
  }

  function orderProcessingSelectChanged(val, text) {
    elsPage.startDate.val("");
    elsPage.timePickerHoursSelect.val("1");
    elsPage.timePickerMinSelect.val("00");
    elsPage.timePickerPeriodSelect.val("AM");
    if (val === "future" || val === "past") {
      elsPage.dateTimePickerSection.show();
      setRequired([elsPage.startDate]);
      setCalendarProperties(val);
    } else {
      removeRequired([elsPage.startDate]);
      elsPage.dateTimePickerSection.hide();
    }
    elsPage.timePickerHoursSelect.change();
    elsPage.timePickerMinSelect.change();
    elsPage.timePickerPeriodSelect.change();

  }

  function setCalendarProperties(selectedDropdownValue) {
    $(".func-date-range-input").datepicker("destroy"); 
    const date = new Date();
    if (selectedDropdownValue === "future") {
      $(".func-date-range-input").datepicker({
        minDate: date,
        todayBtn: "linked",
        keyboardNavigation: false,
        autoclose: true,
        forceParse: false,
        startDate: new Date()
      });
    } else if (selectedDropdownValue === "past") {
      $(".func-date-range-input").datepicker({
        todayBtn: "linked",
        endDate: new Date(),
        maxDate: date,
        keyboardNavigation: false,
        forceParse: false,
        autoclose: true
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/createChannel/walmartConfigurationTab.js